import { CdkDragHandle } from '@angular/cdk/drag-drop';
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    input,
    output,
} from '@angular/core';
import { FormField } from '@angular/forms/signals';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { NgIcon } from '@ng-icons/core';
import { QpxButton, QpxIcon, QpxFormFieldDirectives } from '@quipex/shared/ui';
import type { PackDraftSection } from '../../models';
import { ProposalState } from '../../proposal-state';
@Component({
    selector: 'qpx-quippy-pack-section-heading',
    imports: [
        CdkDragHandle,
        FormField,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatMenuModule,
        NgIcon,
        QpxButton,
        QpxIcon,
        QpxFormFieldDirectives,
    ],
    templateUrl: './section-heading.html',
    styleUrl: '../pack-editor.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class.small]': 'smallHeaders()',
        class: 'section-heading flex min-w-0 items-center gap-1 bg-accent',
    },
})
export class QuippyPackSectionHeading {
    protected readonly draft = inject(ProposalState);
    protected readonly field = computed(() =>
        this.draft.sectionField(this.group().key)
    );
    public readonly smallHeaders = input(false);
    public readonly actionId = input.required<string>();
    public readonly group = input.required<PackDraftSection>();
    public readonly sectionIndex = input.required<number>();
    public readonly last = input(false);
    public readonly disabled = input(false);
    public readonly changed = output<void>();
    public readonly removed = output<void>();
}
